// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zx6p","left":"styles_left__2VGJT","desktopActions":"styles_desktopActions__2LBEt","title":"styles_title__2LVLR"};